
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/favourites",
      function () {
        return require("private-next-pages/user/favourites.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/favourites"])
      });
    }
  